// extracted by mini-css-extract-plugin
export default {"pageContainer":"src_pageContainer__jpPJ6","textNotFound":"src_textNotFound__3fdOO","spinner":"src_spinner__wP6Pb","logo":"src_logo__77t+V","logoDiv":"src_logoDiv__ZUrrL"};